"use client";
import React, { useEffect, useRef } from "react";
import "./components.css";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";

// Assets
import trustpilot from "../assets/Images/Trustpilot.png";
import goodfirms from "../assets/Images/goodfirms.png";
import Clutch from "../assets/Images/Clutch.png";
import AmbitionBox from "../assets/Images/AmbitionBox.png";
import glassdoor from "../assets/Images/glassdoor.png";

// Review Card Component
const ReviewCard = ({ image, alt, rating = "4/5", title }) => {
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const text = textRef.current.innerText;
      textRef.current.innerHTML = text
        .split("")
        .map(
          (char, i) =>
            `<span style="transform:rotate(${i * 10.3}deg)">${char}</span>`
        )
        .join("");
    }
  }, []);

  return (
    <Col xl={4} md={4} sm={6} xs={6}>
      <div className="reviews-rating">
        <div>
          <Image src={image} alt={alt} className="img-fluid" />
          {title && (
            <div className="circle-wrapper">
              <div className="text" ref={textRef}>
                {title}
              </div>
            </div>
          )}
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="30"
              height="30"
              fill="#ff6000"
            >
              <path d="M19.467,23.316,12,17.828,4.533,23.316,7.4,14.453-.063,9H9.151L12,.122,14.849,9h9.213L16.6,14.453Z" />
            </svg>
            <h4 className="text-center p-0 m-0">{rating}</h4>
          </div>
        </div>
      </div>
    </Col>
  );
};

// Main Component
const Reviews = () => {
  const reviews = [
    { image: trustpilot, alt: "Trustpilot", title: "Trustpilot Reviews" },
    { image: goodfirms, alt: "Goodfirms", title: "Goodfirms Reviews" },
    { image: Clutch, alt: "Clutch", title: "Clutch Reviews" },
    { image: AmbitionBox, alt: "AmbitionBox", title: "AmbitionBox Reviews" },
    { image: glassdoor, alt: "Glassdoor", title: "Glassdoor Reviews" },
  ];

  return (
    <div className="reviews">
      <Container className="reviews-main">
        <Row>
          <Col xl={4} md={12} className="reviews-left">
            <h3>
              <span>Excellence.</span>
              <br />
              Our minimum bar for client delivery.
            </h3>
            <p>
              Over 130 awards, accolades, and achievements showcase our quality
              and commitment to client success.
            </p>
          </Col>
          <Col xl={8} md={12}>
            <Row className="p-0 m-0 gy-4">
              {reviews.map((review, index) => (
                <ReviewCard
                  key={index}
                  image={review.image}
                  alt={review.alt}
                  title={review.title}
                />
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Reviews;
